import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectCities} from 'modules/locations/selectors';
import {useMemo} from 'react';
import {ICity} from 'modules/locations/models';
import {useUserCityCode} from './useUserCityCode';

export const useUserCity = (): ICity | undefined => {
    const cityCode = useUserCityCode();
    const citiesList = useAppSelector(selectCities);

    return useMemo<ICity | undefined>(() => citiesList?.find((city) => city.code === cityCode), [citiesList, cityCode]);
};
